/** マトリクス画面でモード・集計期間・列仮想スクロールなどに使う識別子と閾値。 表示レイアウト（幅・バッチ件数）に直結する定数もここに集約し、ロジック側は意味のある名前だけを参照する。 */

export const MODE_STANDALONE = 'standalone'
export const MODE_CONSOLIDATE = 'consolidate'
export const PERIOD_MONTHLY = 'monthly'
export const PERIOD_QUARTER = 'quarter'
export const PERIOD_YEAR = 'year'

/** 年次・四半期表示時に月次マッピングを参照する CHROFY 項目コード接頭辞 */
export const MONTHLY_MAPPED_COLUMN_PREFIX = 'G0006'

/** 列仮想スクロール（ウィンドウィング）: 表示領域の前後に追加で描画する列数。スクロール時の空白を隠す緩衝。 */
export const COLUMN_OVERSCAN = 16
/** 列仮想スクロール: ウィンドウ先頭をこの列数単位に量子化し、再レンダー頻度を抑える（OVERSCAN > STEP で空白を防ぐ）。 STEP を小さくするほど高速スクロール時にウィンドウが追従しやすく、白い空白が出にくい。 */
export const COLUMN_WINDOW_STEP = 4
/** 列仮想スクロール: コンテナ幅が未計測（初期描画・テスト環境 clientWidth=0）のときに用いる既定ビューポート幅(px)。 */
export const COLUMN_VIEWPORT_FALLBACK = 1600

/** 行仮想スクロール: 表示領域の前後に追加で描画する行数。 */
export const ROW_OVERSCAN = 16
/** 行仮想スクロール: ウィンドウ先頭をこの行数単位に量子化する。 STEP を小さくするほど高速スクロール時にウィンドウが追従しやすく、白い空白が出にくい。 */
export const ROW_WINDOW_STEP = 4
/** 行仮想スクロール: 1 行の高さ（px）の既定値。マウント後に実測して上書きする。 */
export const ROW_HEIGHT_FALLBACK = 29
/** 行仮想スクロール: コンテナ高さが未計測のときに用いる既定ビューポート高さ(px)。 */
export const ROW_VIEWPORT_FALLBACK = 800

/** Table width: left columns total and per-column widths */
export const LEFT_COLUMNS_TOTAL_WIDTH = 740
export const COLUMN_WIDTH_WIDE = 80
export const COLUMN_WIDTH_NARROW = 32
export const FEW_COLUMNS_THRESHOLD = 6

/** Left fixed column widths (px) */
export const COL_WIDTH_MAJOR = 140
export const COL_WIDTH_MIDDLE = 140
export const COL_WIDTH_DASHBOARD = 180
export const COL_WIDTH_GRAPH = 200
export const COL_WIDTH_REFERABLE = 80

/** Border color for column groups (shared) */
export const COLUMN_GROUP_BORDER_COLOR = '#b5bac4'

/** Mode labels mapping */
export const MODE_LABELS = {
  [MODE_STANDALONE]: '単体',
  [MODE_CONSOLIDATE]: '連結＆セグメント'
}

/** Period kind labels mapping */
export const PERIOD_LABELS = {
  [PERIOD_MONTHLY]: '月次',
  [PERIOD_QUARTER]: '四半期',
  [PERIOD_YEAR]: '年次'
}
